import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { ComponentProps } from '../../../components/_WMS/FilterComponent/types'
import { createFilterValueWithDisplay } from '../../../types/filters'

// Dirección del movimiento según el DTO: 3 = Entrada, 4 = Salida (TypeMovementeId)
const directionOptions = [
  { value: 3, label: 'Entrada' },
  { value: 4, label: 'Salida' }
]

export const DirectionFilter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  transformForBackend,
  transformForDisplay
}) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const selected = directionOptions.find(
      (option) => option.value.toString() === event.target.value
    )

    let eventValue = ''
    if (selected) {
      if (transformForBackend && transformForDisplay) {
        eventValue = createFilterValueWithDisplay(selected.value, selected.label)
      } else {
        eventValue = selected.value.toString()
      }
    }

    onChange({
      target: { value: eventValue, name: 'typeMovementeId' }
    } as React.ChangeEvent<HTMLInputElement>)
  }

  // Obtener el value numérico a mostrar en el select a partir del value externo
  const selectedValue = (() => {
    if (!value) return '-1'
    try {
      const parsed = JSON.parse(value)
      return parsed.id?.toString() || value
    } catch {
      return value
    }
  })()

  return (
    <TextField
      select
      variant='outlined'
      size='small'
      fullWidth={fullWidth}
      value={selectedValue}
      onChange={handleChange}
      sx={{ height: '44px', '& .MuiInputBase-root': { height: '44px' } }}
    >
      <MenuItem value='-1'>Seleccionar Dirección...</MenuItem>
      {directionOptions.map((option) => (
        <MenuItem key={option.value} value={option.value.toString()}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
